<template>
  <div v-if="isLoading" class="loader-wrapper">
    <div class="loader-container">
      <p v-if="getLoadingMessage">{{ $t(getLoadingMessage) }}</p>
      <i class="loader icon--white fas fa-circle-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('app', ['isLoading', 'getLoadingMessage']),
  },
};
</script>
